'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preact2 = require('unistore/preact');

var _preactFela = require('preact-fela');

var _actions = require('../../actions');

var _constants = require('../../constants');

var _Button = require('../Core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _NavbarProfile = require('./NavbarProfile');

var _NavbarProfile2 = _interopRequireDefault(_NavbarProfile);

var _NavbarList = require('./NavbarList');

var _NavbarList2 = _interopRequireDefault(_NavbarList);

var _NavbarSerasaConsumidor = require('./NavbarSerasaConsumidor');

var _NavbarSerasaConsumidor2 = _interopRequireDefault(_NavbarSerasaConsumidor);

var _CloseIcon = require('../Icon/CloseIcon');

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _Core = require('../Core');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapperStyle = function wrapperStyle(_ref) {
  var open = _ref.open;
  return {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2,
    background: '#ffffff',
    display: open ? 'block' : 'none',
    padding: '0 16px 22px',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch ',
    textAlign: 'center'
  };
};

var navbarHeaderStyle = function navbarHeaderStyle() {
  return {
    display: 'flex',
    justifyContent: 'center',
    margin: 0
  };
};

var closeButtonStyle = function closeButtonStyle(_ref2) {
  var theme = _ref2.theme;
  return {
    position: 'absolute',
    top: '7px',
    left: '0px',
    fontWeight: '500',
    color: theme.color
  };
};

var CloseButtonIconStyles = function CloseButtonIconStyles() {
  return {
    marginRight: '5px'
  };
};

var brandStyle = function brandStyle() {
  return {
    height: '24px'
  };
};

var Brand = (0, _preactFela.createComponent)(brandStyle, 'img', ['src', 'alt']);

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);
var NavbarHeader = (0, _preactFela.createComponent)(navbarHeaderStyle, 'section');
var CloseButton = (0, _preactFela.createComponent)(closeButtonStyle, _Button2.default);
var CloseButtonIcon = (0, _preactFela.createComponent)(CloseButtonIconStyles, _CloseIcon2.default, ['color']);

exports.default = (0, _preact2.connect)('brand,login,signUp,config,heimdall', {
  goMenu: function goMenu(evt, menu) {
    return (0, _actions.goMenu)(evt, menu);
  },
  closeMenu: function closeMenu() {
    return (0, _actions.toggleMenuDropdown)('menu');
  },
  logout: _actions.logout
})(function (props) {
  var brand = props.brand,
      config = props.config,
      heimdall = props.heimdall,
      menus = props.menus,
      loggedIn = props.loggedIn,
      login = props.login,
      signUp = props.signUp,
      profile = props.profile;

  return (0, _preact.h)(
    Wrapper,
    { open: heimdall.dropdown.menu },
    (0, _preact.h)(
      NavbarHeader,
      null,
      (0, _preact.h)(
        CloseButton,
        _extends({ onClick: props.closeMenu }, (0, _utils.getAttrsGtm)("fechar", { clicktype: 'menu-lateral' })),
        [(0, _preact.h)(CloseButtonIcon, { color: config.color }), 'fechar']
      ),
      (0, _preact.h)(
        _Button2.default,
        { padding: '12px 16px 8px' },
        (0, _preact.h)(Brand, { src: brand.logo.default, alt: brand.logo.alt })
      )
    ),
    (0, _preact.h)(_NavbarProfile2.default, {
      loggedIn: loggedIn,
      profile: profile,
      login: login,
      signUp: signUp,
      logout: props.logout,
      closeMenu: props.closeMenu,
      config: config
    }),
    (0, _preact.h)(_NavbarList2.default, { menus: menus, config: config, mobile: true, goMenu: function goMenu(evt, menu) {
        props.closeMenu();
        props.goMenu(evt, menu);
      } }),
    (0, _preact.h)(_NavbarSerasaConsumidor2.default, { config: config, heimdall: heimdall, mobile: true }),
    (0, _preact.h)(Brand, { src: '' + heimdall.host + _constants.PRODUCTS[_constants.SERASA].logoGray, alt: 'SerasaConsumidor' })
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Navbar/NavbarMobile.js
// module id = 196
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38